<template>
<div>
    <LabelWithHelpText>
        Status
        <template #help>{{ helpText }}</template>
    </LabelWithHelpText>
    <div class="field">
        <div class="control">
            <textarea-autosize
                :value="value"
                @input.native="$emit('input', $event.target.value)"
                :maxLength="$const.MESSAGE_TO_VIEWER_MAX_LENGTH"
                :maxHeight="90"
                placeholder="What should I play?"
                rows="1"
                class="input"/>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'ConfigMessageToViewers',
    props: {
        value: String
    },
    computed: {
        helpText: vm => `${vm.value.length}/${vm.$const.MESSAGE_TO_VIEWER_MAX_LENGTH}`
    },
}
</script>

<style lang="scss" scoped>

</style>
